module.exports = __webpack_public_path__ + "static/media/bgHD.bf741a9a.jpg";